// appCreationActions.js
export const SET_SELECTED_FRAMEWORK = 'SET_SELECTED_FRAMEWORK';
export const SET_CHAT_APP_NAME = 'SET_CHAT_APP_NAME';
export const SET_SELECTED_APP_TYPE = 'SET_SELECTED_APP_TYPE';
export const SET_THEME_SETTINGS = 'SET_THEME_SETTINGS';
export const SET_SELECTED_KEY = 'SET_SELECTED_KEY';
export const SET_BOT_CONTENT = 'SET_BOT_CONTENT';
export const RESET_APP_CREATION = 'RESET_APP_CREATION';

// Action Creators
export const setSelectedFramework = (framework) => ({
  type: SET_SELECTED_FRAMEWORK,
  payload: framework
});

export const setChatAppName = (name) => ({
  type: SET_CHAT_APP_NAME,
  payload: name
});

export const setSelectedAppType = (appType) => ({
  type: SET_SELECTED_APP_TYPE,
  payload: appType
});

export const setThemeSettings = (settings) => ({
  type: SET_THEME_SETTINGS,
  payload: settings
});

export const setSelectedKey = (key) => ({
  type: SET_SELECTED_KEY,
  payload: key
});

export const setBotContent = (botContent) => ({
  type: SET_BOT_CONTENT,
  payload: botContent
});

export const resetAppCreation = () => ({
  type: RESET_APP_CREATION
});